import React, { useLayoutEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import Cvss from 'pages/Search/components/Cvss';
import Database from 'pages/Search/components/Database';
import ProductCveList from 'pages/Search/components/ProductCveList';
import Products from 'pages/Search/components/Products';
import ProductVersions from 'pages/Search/components/ProductVersions';
import TypesCveList from 'pages/Search/components/TypesCveList';
import Vendor from 'pages/Search/components/Vendor';
import Vendors from 'pages/Search/components/Vendors';
import Years from 'pages/Search/components/Years';
import { normalizeUri } from 'pages/Search/utils';

import { ROUTES } from './constants';

const Search = () => {
    useLayoutEffect(() => {
        window.history.replaceState(
            null,
            document.title,
            normalizeUri(window.location.pathname, { dedupe: true }).concat(window.location.search)
        );
    }, []);

    return (
        <Switch>
            <Route exact path={ROUTES.SEARCH()} component={Database} />
            <Route
                exact
                path={[
                    ROUTES.TYPES_CVE({ type: ':type', order: null, page: ':page' }),
                    ROUTES.TYPES_CVE({ type: ':type', order: null, page: null }),
                    ROUTES.TYPES_CVE({ type: ':type', order: ':order(most-viewed)', page: ':page' }),
                    ROUTES.TYPES_CVE({ type: ':type', order: ':order(most-viewed)', page: null })
                ]}
                component={TypesCveList}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDORS({ letter: ':letter', page: ':page' }),
                    ROUTES.VENDORS({ letter: ':letter', page: null }),
                    ROUTES.VENDORS({ letter: null, page: ':page' }),
                    ROUTES.VENDORS({ letter: null, page: null })
                ]}
                component={Vendors}
            />
            <Route
                exact
                path={[
                    ROUTES.VENDOR({ vendor: ':vendor', letter: ':letter', page: ':page' }),
                    ROUTES.VENDOR({ vendor: ':vendor', letter: ':letter', page: null }),
                    ROUTES.VENDOR({ vendor: ':vendor', letter: null, page: ':page' }),
                    ROUTES.VENDOR({ vendor: ':vendor', letter: null, page: null })
                ]}
                component={Vendor}
            />
            <Route
                exact
                path={[
                    ROUTES.PRODUCTS({ letter: ':letter', page: ':page' }),
                    ROUTES.PRODUCTS({ letter: ':letter', page: null }),
                    ROUTES.PRODUCTS({ letter: null, page: ':page' }),
                    ROUTES.PRODUCTS({ letter: null, page: null })
                ]}
                component={Products}
            />
            <Route
                exact
                path={[
                    ROUTES.PRODUCT_VERSIONS({ vendor: ':vendor', product: ':product', page: ':page' }),
                    ROUTES.PRODUCT_VERSIONS({ vendor: ':vendor', product: ':product', page: null })
                ]}
                component={ProductVersions}
            />
            <Route
                exact
                path={[
                    ROUTES.PRODUCT_CVES({ vendor: ':vendor', product: ':product', version: null, page: ':page' }),
                    ROUTES.PRODUCT_CVES({ vendor: ':vendor', product: ':product', version: null, page: null }),
                    ROUTES.PRODUCT_CVES({ vendor: ':vendor', product: ':product', version: ':version', page: ':page' }),
                    ROUTES.PRODUCT_CVES({ vendor: ':vendor', product: ':product', version: ':version', page: null })
                ]}
                component={ProductCveList}
            />
            <Route
                exact
                path={[
                    ROUTES.YEARS({ page: ':page', year: ':year', month: ':month' }),
                    ROUTES.YEARS({ page: ':page', year: ':year', month: null }),
                    ROUTES.YEARS({ page: ':page', year: null, month: ':month' }),
                    ROUTES.YEARS({ page: ':page', year: null, month: null }),
                    ROUTES.YEARS({ page: null, year: ':year', month: ':month' }),
                    ROUTES.YEARS({ page: null, year: ':year', month: null }),
                    ROUTES.YEARS({ page: null, year: null, month: ':month' }),
                    ROUTES.YEARS({ page: null, year: null, month: null })
                ]}
                component={Years}
            />
            <Route
                exact
                path={[
                    ROUTES.CVSS({ page: ':page', cvss: ':cvss' }),
                    ROUTES.CVSS({ page: ':page', cvss: null }),
                    ROUTES.CVSS({ page: null, cvss: ':cvss' }),
                    ROUTES.CVSS({ page: null, cvss: null })
                ]}
                component={Cvss}
            />
            <Route path={[ROUTES.TAGS({ tag: ':tag' })]} component={Database} />
            <Route path={'*'} render={() => <Redirect to="/search" />} />
        </Switch>
    );
};

export default Search;
